var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40587 42.8467C4.62109 42.8467 3.10725 42.3704 1.86435 41.418C0.621451 40.4656 0 39.3055 0 37.9378V19.3417C0 17.9737 0.621451 16.8135 1.86435 15.8611C3.10725 14.9086 4.62109 14.4324 6.40587 14.4324H12.4624V19.3417H6.40587V37.9378H34.5941V19.3417H28.5376V14.4324H34.5941C36.3789 14.4324 37.8927 14.9086 39.1357 15.8611C40.3786 16.8135 41 17.9737 41 19.3417V37.9378C41 39.3055 40.3786 40.4656 39.1357 41.418C37.8927 42.3704 36.3789 42.8467 34.5941 42.8467H6.40587ZM17.2971 29.7489V9.3629L13.4294 12.3267L8.95191 8.87525L20.5 0L32.0481 8.87525L27.5706 12.3267L23.7029 9.3629V29.7489H17.2971Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.58ad04d62387406b3351b140bf12213e.svg";
export { ForwardRef as ReactComponent };